export class PropertyDocumentBase {
  id: string;
  name: string;
  sourceVersion: string;
  ObjectTypes: PropertyDocument[];
  constructor(data) {
    Object.assign(this, data);
  }
}

export class PropertyDocument {
  id: string;
  Properties: Property[];
  constructor(data) {
    Object.assign(this, data);
  }
}

export class Property {
  name: string;
  type: string;
  picklist: string;
  category: string;
  valuelist: string;
  opath: string;
  visibleIndex: number;
  visibility: number;

  constructor(data) {
    Object.assign(this, data);
  }
}

export class PropertyBCEDocument {
  PropertyDocument: string;
  PropertyDocumentFallBack: string;
  constructor(data) {
    Object.assign(this, data);
  }
}

export class PropertyModel {
  Designation: string;
  TextValue: string;
  Type: number;
  Id: string;

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class PickList {
  Designation: string;
  Name: string;
  Id: string;

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export enum PropertyType {
  Text = '0',
  Number = '1',
  Boolean = '2',
  Picklist = '3',
  ListOfValues = '4',
  ConfigurationDocument = '5',
}

export class PropertyDocumentSource {
  objectSpaceName?: string;
  objectType: string;
  opath: string;
}
